import { Box, Heading, Text, Stack, Badge, ImageIcon, Card } from '@/components/lib'

const EmptyCard = props => {
  return (
    <Card variant='elevated' size={props.compact ? 'sm' : 'md'} gap={props.compact ? 4 : 8} maxWidth='400px' {...props}>
      {props.icon &&
        <Stack direction='row'>
          <ImageIcon title={props.title} iconKey={props.icon} size={props.compact ? 30 : 50} />
        </Stack>}
      <Stack direction='column' gap={props.compact ? 1 : 2}>
        {props.badge &&
          <Box>
            <Badge colorPalette='blue'>{props.badge}</Badge>
          </Box>}
        <Heading as='h3' size='md' color='fg.default'>{props.title}</Heading>
        <Text fontSize='sm' color='fg.muted'>{props.description}</Text>
      </Stack>
      {((props.children || props.action) &&
        <Box>{props.children || props.action}</Box>
      )}
    </Card>
  )
}

export default EmptyCard
